import React from "react";
import { NewModal, MainContentPaddingTypes, useAicoConnection } from "../..";
import NewButton from "../../BaseComponents/newButton";
import { useMutation } from "@apollo/client";
import { RESET_FEEDING_TIMES, ResetFeedingTimesArgs, ResetFeedingTimesResponse } from "../../../Services/Agrisys_GqlDataCaller/ServiceToolCalls/GQLCalls/resetFeedingTimes";
import { colors, fonts } from "../../../Styles";
import { LoadingSpinner } from "../../../Services/wrapper";

interface ResetFeedTimesProps {
	isModalOpen: boolean;
	closeModal: () => void;
	onSuccess: () => void;
}

export default function ResetFeedTimesModal({
	isModalOpen,
	closeModal,
	onSuccess
}: ResetFeedTimesProps) {
	const { state: connectionState } = useAicoConnection();

	const [resetFetch, { data: resetData, loading: resetLoading, error: resetError, reset: resetResetState }] = useMutation<ResetFeedingTimesResponse, ResetFeedingTimesArgs>(RESET_FEEDING_TIMES, {
		fetchPolicy: "network-only"
	});

	async function handleResetFeedTimes() {
		if (!connectionState.deviceConnection) {
			return;
		}

		const result = await resetFetch({ variables: connectionState.deviceConnection });
		if (result.data?.controller.resetFeedingTimes?.success) {
			onSuccess();
		}
	}

	function handleCloseModal() {
		resetResetState();
		closeModal();
	}

	return (
		<NewModal
			modalState={isModalOpen}
			header={"Reset Feed Times"}
			predefinedButtons={{
				onClose: handleCloseModal,
			}}
			overrides={{
				mainContentPadding: MainContentPaddingTypes.secondary,
			}}
			mainContent={
				<div
					style={{
						display: "flex",
						flexDirection: "column",
						alignItems: "center",
						gap: "60px",
						marginTop: "25px",
					}}
				>
					<div
						style={{
							display: "flex",
							flexDirection: "column",
							alignItems: "center",
							gap: "10px",
						}}
					>
						<p style={{ ...fonts.fontSize1, ...fonts.header, color: colors.whitePrimary }}>WARNING!</p>
						<p style={{ ...fonts.fontSize3, ...fonts.header, color: colors.whitePrimary, textAlign: "center" }}>
							This action will reset the feed times on the LAN Controller, <br/> 
							this action is irreversible!
						</p>
						{resetLoading && <LoadingSpinner />}
						{(resetError
							|| (resetData?.controller && !resetData.controller.resetFeedingTimes?.success)
						)
							&& <p style={{ ...fonts.fontSize2, ...fonts.paragraph, color: colors.systemRed, maxWidth: "500px" }}>ERROR: Failed To Reset Feed Times</p>
						}
						{!resetLoading
							&& !resetError
							&& resetData?.controller.resetFeedingTimes?.success
							&& <p style={{ ...fonts.fontSize2, ...fonts.paragraph, color: colors.systemGreen, maxWidth: "500px" }}>Succesfully Reset Feed Times</p>
						}
					</div>
					<div
						style={{
							display: "flex",
							flexDirection: "row",
							alignItems: "center",
							gap: "5px",
						}}
					>
						<NewButton
							content={"Reset Feed times"}
							onClick={handleResetFeedTimes}
							disabled={resetLoading}
						/>
						<NewButton
							content={"Cancel"}
							onClick={handleCloseModal}
							disabled={resetLoading}
						/>
					</div>
				</div>
			}
		/>
	);
}
